import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, Directive, Input, HostListener, NgModule } from '@angular/core';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import * as i2 from '@angular/router';
import { ActivationEnd } from '@angular/router';
function _window() {
  return window;
}
let WindowRef = /*#__PURE__*/(() => {
  class WindowRef {
    constructor(platformId) {
      this.platformId = platformId;
    }
    get nativeWindow() {
      if (isPlatformBrowser(this.platformId)) {
        return _window();
      }
      return {};
    }
    /** @nocollapse */
    static {
      this.ɵfac = function WindowRef_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WindowRef)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WindowRef,
        factory: WindowRef.ɵfac
      });
    }
  }
  return WindowRef;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// our root app component
/** @dynamic */
let TagCommanderService = /*#__PURE__*/(() => {
  class TagCommanderService {
    debug_logger(...args) {
      if (this.debug) {
        console.log.apply(console, args);
      }
    }
    constructor(winRef, router, _doc, platformId) {
      this.winRef = winRef;
      this.router = router;
      this._doc = _doc;
      this.platformId = platformId;
      this._tcContainers = [];
      this._trackRoutes = false;
      this.captureEvent = this.triggerEvent;
      this.router.events.subscribe(_data => {
        if (_data instanceof ActivationEnd && this._trackRoutes) {
          if (_data.snapshot.data.tcInclude !== undefined) {
            const data = _data.snapshot.data.tcInclude;
            data.forEach(container => {
              this.reloadContainer(container['ids'], container['idc'], container['options']);
            });
          }
        }
      });
    }
    // /**
    //  * the script URI correspond to the tag-commander script URL, it can either be a CDN URL or the path of your script
    //  * @param {string} id: the id the script node will have
    //  * @param {string} uri: the source of the script
    //  * @param {string} node: the node on witch the script will be placed, it can either be head or body
    //  * @param {array} args: contains extra args for script tag like crossorigin
    // */
    addContainer(id, uri, node, args = []) {
      return new Promise(resolve => {
        this._tcContainers.push({
          id: id,
          uri: uri
        });
        const tagContainer = this._doc.createElement('script');
        tagContainer.onload = () => resolve();
        tagContainer.setAttribute('type', 'text/javascript');
        tagContainer.setAttribute('src', uri);
        tagContainer.setAttribute('id', id);
        if (Array.isArray(args) && args.length > 0) {
          args.forEach(([key, value]) => tagContainer.setAttribute(key, value));
        }
        if (typeof node !== 'string') {
          this.debug_logger('you didn\'t specify where you wanted to place the script, it will be placed in the head by default');
          this._doc.querySelector('head').appendChild(tagContainer);
        } else if (node.toLowerCase() === 'head' || node.toLowerCase() === 'body') {
          this._doc.querySelector(node.toLowerCase()).appendChild(tagContainer);
        } else {
          this.debug_logger('you didn\'t correctily specify where you wanted to place the script, it will be placed in the head by default');
          this._doc.querySelector('head').appendChild(tagContainer);
        }
      });
    }
    // /**
    //  * The script URI correspond to the tag-commander script URL, it can either be a CDN URL or the path of your script
    //  * @param {string} id
    //  */
    removeContainer(id) {
      const container = this._doc.getElementById(id);
      const containers = this._tcContainers.slice(0);
      for (let i = 0; i < containers.length; i++) {
        if (containers[i].id === id) {
          const node = containers[i].node.toLowerCase();
          const parent = this._doc.getElementsByTagName(node)[0];
          if (parent && container && container.parentNode === parent) {
            parent.removeChild(container);
          }
          this._tcContainers.splice(i, 1);
        }
      }
    }
    // /**
    //  * will display the debug messages if true
    //  * @param {boolean} debug: if set to true it will activate the debug msg default is false
    //  */
    setDebug(debug) {
      this.debug = debug;
    }
    // /**
    //  * allows the router to be tracked
    //  * @param {boolean} b: will read routes if set to true
    //  */
    trackRoutes(b) {
      this._trackRoutes = !!b;
    }
    // /**
    //  * set or update the value of the var
    //  * @param {string} tcKey
    //  * @param {*} tcVar
    //  */
    setTcVar(tcKey, tcVar) {
      if (isPlatformBrowser(this.platformId)) {
        if (!this.winRef.nativeWindow.tc_vars) {
          throw new Error('[ngx-tag-commander] setTcVar failed because no window.tc_vars was found. Did you initialize it?');
        }
        this.winRef.nativeWindow.tc_vars[tcKey] = tcVar;
      }
    }
    // /**
    //  * set your variables for the different providers, when called the first time it
    //  * instantiate the external variable
    //  * @param {object} vars
    //  */
    setTcVars(vars) {
      if (isPlatformBrowser(this.platformId)) {
        this.debug_logger('setTcVars', vars);
        const listOfVars = Object.keys(vars);
        for (let i = 0; i < listOfVars.length; i++) {
          this.setTcVar(listOfVars[i], vars[listOfVars[i]]);
        }
      }
    }
    // /**
    //  * get the value of the var
    //  * @param {string} tcKey
    //  */
    getTcVar(tcKey) {
      if (isPlatformBrowser(this.platformId)) {
        this.debug_logger('getTcVar', tcKey);
        if (this.winRef.nativeWindow.tc_vars[tcKey] === null || this.winRef.nativeWindow.tc_vars[tcKey] === undefined) {
          throw new Error('[ngx-tag-commander]tc_var is undefined. Check that it\'s properly initialized');
        }
        return this.winRef.nativeWindow.tc_vars[tcKey];
      }
    }
    // /**
    //  * removes the var by specifying the key
    //  * @param {string} tcKey
    //  */
    removeTcVar(tcKey) {
      if (isPlatformBrowser(this.platformId)) {
        this.debug_logger('removeTcVar', tcKey);
        delete this.winRef.nativeWindow.tc_vars[tcKey];
      }
    }
    // /**
    //  * will reload all the containers
    //  * @param {object} options: can contain some options in a form of an object
    //  */
    reloadAllContainers(options = {}) {
      if (isPlatformBrowser(this.platformId)) {
        this.debug_logger('Reload all containers ', options);
        if (!this.winRef.nativeWindow.tC) {
          return window.setTimeout(() => {
            this.reloadAllContainers(options);
          }, 1000);
        }
        this.winRef.nativeWindow.tC.container.reload(options);
      }
    }
    // /**
    //  * will reload the specified container
    //  * @param {number} siteId
    //  * @param {number} idc
    //  * @param {object} options: can contain some options in a form of an object
    //  */
    reloadContainer(siteId, containerId, options) {
      if (isPlatformBrowser(this.platformId)) {
        options = options || {};
        if (!this.winRef.nativeWindow.tC) {
          return window.setTimeout(() => {
            this.reloadContainer(siteId, containerId, options);
          }, 1000);
        }
        this.debug_logger('Reload container ids: ' + siteId + ' idc: ' + containerId, typeof options === 'object' ? 'with options: ' : '', options || '');
        this.winRef.nativeWindow.tC['container_' + siteId + '_' + containerId].reload(options);
      }
    }
    // /**
    //  * will set an TagCommander event
    //  * @param {string} eventLabel: the name of your event
    //  * @param {HTMLElement} htmlElement: the HTMLElement on witch the event is attached
    //  * @param {object} data: the data you want to transmit
    //  */
    triggerEvent(eventLabel, htmlElement, data, reloadCapture = false) {
      if (isPlatformBrowser(this.platformId)) {
        if (reloadCapture !== true) {
          this.debug_logger('triggerEvent', eventLabel, htmlElement, data);
          if (typeof this.winRef.nativeWindow.tC !== 'undefined') {
            if (eventLabel in this.winRef.nativeWindow.tC.event) {
              this.winRef.nativeWindow.tC.event[eventLabel](htmlElement, data);
            }
            if (!(eventLabel in this.winRef.nativeWindow.tC.event)) {
              setTimeout(() => {
                this.triggerEvent(eventLabel, htmlElement, data, reloadCapture = true);
              }, 1000);
            }
          }
        }
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function TagCommanderService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TagCommanderService)(i0.ɵɵinject(WindowRef), i0.ɵɵinject(i2.Router), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TagCommanderService,
        factory: TagCommanderService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TagCommanderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TcSetVarsDirective = /*#__PURE__*/(() => {
  class TcSetVarsDirective {
    constructor(el, tcService) {
      this.el = el;
      this.tcService = tcService;
    }
    ngAfterViewInit() {
      this.tcService.setTcVars(this.tcSetVars);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function TcSetVarsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TcSetVarsDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TagCommanderService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TcSetVarsDirective,
        selectors: [["", "tcSetVars", ""]],
        inputs: {
          tcSetVars: "tcSetVars"
        },
        standalone: false
      });
    }
  }
  return TcSetVarsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// usage [tcEvent]
let TcEventDirective = /*#__PURE__*/(() => {
  class TcEventDirective {
    constructor(el, tcService) {
      this.el = el;
      this.tcService = tcService;
    }
    onClick() {
      if (typeof this.tcEvent === 'object' && (this.tcEventLabel === undefined || this.tcEventObj === undefined)) {
        try {
          this.tcService.triggerEvent(this.tcEvent.eventLabel, this.el, this.tcEvent.data);
        } catch (e) {
          console.error(e);
        }
      } else {
        this.tcService.triggerEvent(this.tcEventLabel, this.el, this.tcEventObj);
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function TcEventDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TcEventDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TagCommanderService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TcEventDirective,
        selectors: [["", "tcEvent", ""]],
        hostBindings: function TcEventDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function TcEventDirective_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
        },
        inputs: {
          tcEvent: "tcEvent",
          tcEventLabel: "tcEventLabel",
          tcEventObj: "tcEventObj"
        },
        standalone: false
      });
    }
  }
  return TcEventDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxTagCommanderModule = /*#__PURE__*/(() => {
  class NgxTagCommanderModule {
    /** @nocollapse */static {
      this.ɵfac = function NgxTagCommanderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxTagCommanderModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxTagCommanderModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [TagCommanderService],
        imports: [CommonModule]
      });
    }
  }
  return NgxTagCommanderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-tag-commander
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxTagCommanderModule, TagCommanderService, TcEventDirective, TcSetVarsDirective, WindowRef };
